import Page from "~/shared/Page";
import usePublicNavbar from "./use-public-navbar";

export default function PublicPage({ forRole = "FAMILY", children, title, heading = title, documentTitle, navBar, size = "max-w-lg", className = "" }) {
    const publicNavbar = usePublicNavbar(forRole !== "ADMIN");

    return (
        <Page className={`${forRole.toLowerCase()}-bg`} documentTitle={documentTitle} title={title} showTranslator={forRole === "FAMILY"} navBar={navBar ?? publicNavbar} external>
            <div className="flex flex-col flex-1">
                <div className={`portal-container p-8 py-6 ${size} ${className}`}>
                    <h2 className="text-2xl font-semibold text-left mb-5">{heading}</h2>
                    {children}
                </div>
            </div>
        </Page>
    );
}